export const STEP_DOCUMENT = "document";
export const STEP_FACE = "face";
export const STEP_POA = "poa";
export const STEP_COMPLETE = "complete";
function isStepsWithDocument(steps) {
    return steps.includes(STEP_DOCUMENT);
}
function isStepsWithFace(steps) {
    return steps.includes(STEP_FACE);
}
function isStepsWithPoa(steps) {
    return steps.includes(STEP_POA);
}
function isStepsWithComplete(steps) {
    return steps.includes(STEP_COMPLETE);
}
export function getSteps(steps, allowedDocuments) {
    const stepConfigurations = [];
    if (isStepsWithDocument(steps)) {
        stepConfigurations.push({
            type: STEP_DOCUMENT,
            options: {
                forceCrossDevice: true,
                useLiveDocumentCapture: true,
                uploadFallback: true,
                documentTypes: getAllowedDocumentTypes(allowedDocuments),
            },
        });
    }
    if (isStepsWithFace(steps)) {
        stepConfigurations.push(STEP_FACE);
    }
    if (isStepsWithPoa(steps)) {
        stepConfigurations.push({
            type: STEP_POA,
            options: {
                documentTypes: {
                    utility_bill: true,
                    bank_building_society_statement: true,
                    council_tax: false,
                    benefit_letters: false,
                    government_letter: false,
                },
            },
        });
    }
    if (isStepsWithComplete(steps)) {
        stepConfigurations.push(STEP_COMPLETE);
    }
    return stepConfigurations;
}
const DEFAULT_ALLOWED_DOCUMENT_TYPES = {
    passport: true,
    national_identity_card: true,
};
function getAllowedDocumentTypes(allowedDocuments) {
    if (!allowedDocuments) {
        return DEFAULT_ALLOWED_DOCUMENT_TYPES;
    }
    return allowedDocuments.reduce((acc, curr) => {
        return Object.assign(Object.assign({}, acc), { [curr]: true });
    }, {});
}
